import { useQuery } from '@tanstack/react-query';

import { getAdminRoster } from '../../../api/chats';
import type { ChatAdminSummary } from '../../../types/admin';
import { useAuth } from '../../auth/AuthProvider';

export function useAdminRoster() {
  const { tokens } = useAuth();

  return useQuery<readonly ChatAdminSummary[]>({
    queryKey: ['admin-roster'],
    queryFn: () => getAdminRoster(tokens!.access_token),
    enabled: Boolean(tokens?.access_token),
    staleTime: 60_000,
  });
}
